import {
  Box,
  Breadcrumbs,
  Button,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
} from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import * as services from "./../../services/saleng";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { jwtDecode } from "jwt-decode";

const Branches = () => {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [rowModesModel, setRowModesModel] = useState({});
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(null);

  const columns = [
    { field: "id", headerName: "ลำดับ", flex: 0, width: 70 },
    { field: "name", headerName: "ชื่อสาขา", flex: 1, editable: true },
    { field: "description", headerName: "คำอธิบาย", flex: 1, editable: false },
    { field: "count", headerName: "จำนวนสมาชิก", flex: 1, editable: false },
    // {
    //   field: "stock",
    //   headerName: "คลังสินค้า",
    //   flex: 1,
    //   editable: false,
    //   renderCell: (params) => {
    //     return (
    //       <Button
    //         variant="contained"
    //         startIcon={<StorefrontIcon />}
    //         onClick={() => navigate(`/branches/stock/${params.row.branchId}`)}
    //       >
    //         คลังสินค้า
    //       </Button>
    //     );
    //   },
    // },
    {
      field: "actions",
      headerName: "",
      flex: 0,
      headerAlign: "center",
      align: "center",
      renderCell: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              key={`${id}-save`}
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main",
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              key={`${id}-cancel`}
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />,
          ];
        }

        return [
          <GridActionsCellItem
            key={`${id}-edit`}
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            key={`${id}-delete`}
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleEditClick = (id) => () => {
    const branch = rows.find((row) => row.id === id);
    navigate(`/branches/edit/${branch.branchId}`);
  };

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    const deletedRow = rows.find((row) => row.id === id);
    // // console.log("deletedRow :",deletedRow)

    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      title: "ยืนยันที่จะลบ?",
      text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ยืนยัน",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        services
          .deleteBranch(deletedRow.branchId)
          .then((response) => {
            console.log("Product deleted successfully:", response);
            toast.success("ลบสำเร็จ!");
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              title: "ลบแล้ว!",
              text: deletedRow.name + " ถูกลบแล้ว",
              icon: "success",
              confirmButtonText: "ตกลง",
            });
            setRows((prevRows) =>
              prevRows
                .filter((row) => row.branchId !== deletedRow.branchId)
                .map((item, index) => ({
                  ...item,
                  id: index + 1,
                }))
            );
          })
          .catch((error) => {
            toast.error("ลบไม่สำเร็จ!");
            console.error("Error deleting product:", error);
          });
      }
    });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const processRowUpdate = (newRow) => {
    const payload = {
      name: newRow.name,
    };

    console.log("payload : ", payload);

    services
      .updateBranch(newRow.branchId, payload)
      .then((response) => {
        toast.success("แก้ไขสำเร็จ!");
        console.log("Product updated successfully:", response);
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      })
      .catch((error) => {
        toast.error("แก้ไขไม่สำเร็จ!");
        console.error("Error creating product:", error);
      });

    const originalRow = revertData(newRow);
    return originalRow; // คืนค่าผลลัพธ์เดิม
  };

  const revertData = (newRow) => {
    const originalRow = rows.find((row) => row.id === newRow.id);

    if (originalRow) {
      setRows(rows.map((row) => (row.id === newRow.id ? originalRow : row)));
    }

    setRowModesModel({
      ...rowModesModel,
      [newRow.id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    console.log("Cancel the edit and revert to the original data");
    return originalRow;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!shopId) return;

        const shopResponse = await services.getShop(shopId);
        const shop = shopResponse.data.data;
        // console.log("Shop data fetched:", shop);

        const shopsWithIndex = shop.branches.map((item, index) => ({
          ...item,
          id: index + 1,
          branchId: item.id,
          count: item._count.users,
        }));

        setRows(shopsWithIndex);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        if (decoded.id) {
          setShopId(decoded.id);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    
    fetchData();
  }, [shopId]);

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, mb: 2 }}>
        <Link underline="hover" color="inherit" href="/">
          หน้าแรก
        </Link>
        <Typography color="text.primary">จัดการสาขา</Typography>
      </Breadcrumbs>

      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component="h2" variant="h5">
          จัดการสาขา
        </Typography>

        <Button
          color="success"
          variant="contained"
          onClick={() => navigate("/branches/add")}
        >
          เพิ่มสาขา
        </Button>
      </Box>
      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid
              rows={rows}
              columns={columns}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              loading={loading}
              slotProps={{
                toolbar: { setRows, setRowModesModel },
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
              }}
              initialState={{ pagination: { page: 0, pageSize: 50 } }}
              pageSizeOptions={[25, 50, 100]}
              // getRowId={(row) => row.id}
              // checkboxSelection
              // onRowSelectionModelChange={(newRowSelectionModel) => {
              //   setRowSelectionModel(newRowSelectionModel);
              // }}
            />
          </Paper>
        </Box>
      </Box>
    </div>
  );
};

export default Branches;
